import React from 'react';
import IconAbstract from '../../Lib/Components/IconAbstract';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faFilter} from '@fortawesome/free-solid-svg-icons';

class FilterIcon extends IconAbstract {
	renderIcons()
	{
		return (
			<FontAwesomeIcon icon={faFilter}/>
		)
	}
}

export default FilterIcon;
